import React from 'react';
import AddressField from './AddressField';
import { useAddressField, AddressFieldValue } from '../hooks/useAddressField';

export interface AddressFieldWrapperProps {
  initialAddress?: string | any | null;
  onAddressChange?: (address: AddressFieldValue) => void;
  isEditMode?: boolean;
  labelWidth?: number;
  styleDisplay?: 'small' | 'medium';
  disabled?: boolean; // Disable all address fields when user only has read permission
  defaultProvinceOnEmpty?: boolean;
}

const AddressFieldWrapper: React.FC<AddressFieldWrapperProps> = ({
  initialAddress,
  onAddressChange,
  isEditMode = true,
  labelWidth = 150,
  styleDisplay = 'small',
  disabled = false,
  defaultProvinceOnEmpty = true,
}) => {
  const {
    addressValue,
    handleAddressChange,
  } = useAddressField({
    initialAddress,
    onAddressChange,
  });

  return (
    <AddressField
      value={addressValue}
      onChange={handleAddressChange}
      isEditMode={isEditMode}
      labelWidth={labelWidth}
      styleDisplay={styleDisplay}
      disabled={disabled}
      defaultProvinceOnEmpty={defaultProvinceOnEmpty}
    />
  );
};

export default AddressFieldWrapper;
